import styles from './LPFooterNav.module.scss'

interface ServiceLink {
  href: string
  title: string
}

interface CategoryLink {
  href: string
  title: string
}

const serviceLinks: ServiceLink[] = [
  {
    href: '/services/servicedesign',
    title: 'サービスデザイン',
  },
  {
    href: '/services/designsprint',
    title: 'デザインスプリント',
  },
  {
    href: '/services/uiuxdesign',
    title: 'UX/UIデザイン',
  },
  {
    href: '/services/od',
    title: '組織開発・イノベーション',
  },
  {
    href: '/services/mobileapp',
    title: 'モバイルアプリ',
  },
  {
    href: '/services/frontend',
    title: 'フロントエンド',
  },
  {
    href: '/services/webapp',
    title: 'ウェブアプリ',
  },
  {
    href: '/services/xr',
    title: 'xR/アプリ開発',
  },
  {
    href: '/services/cloudservice',
    title: 'クラウド活用サービス',
  },
  {
    href: '/services/growthhack',
    title: 'サイト改善ソリューション',
  },
  {
    href: '/services/appgrowth',
    title: 'プロダクトグロース・UX改善支援',
  },
]

const categoryLinks: CategoryLink[] = [
  {
    href: '/case',
    title: 'Case',
  },
  {
    href: '/about',
    title: 'About',
  },
  {
    href: '/topics/all/page/1',
    title: 'Topics',
  },
  {
    href: '/recruit',
    title: 'Recruit',
  },
  {
    href: '/download',
    title: 'Download',
  },
  {
    href: '/contact',
    title: 'Contact',
  },
]

const LPFooterNav: React.FC = () => {
  const serviceList = serviceLinks.map(
    ({ href, title }): JSX.Element => (
      <div className={styles.detail} key={title}>
        <a href={href} target="_blank" rel="noopener">
          <span className={styles.grey_text}>{title}</span>
        </a>
      </div>
    ),
  )

  const categoryList = categoryLinks.map(
    ({ href, title }): JSX.Element => (
      <a href={href} key={title} target="_blank" rel="noopener">
        <span className={styles.category}>{title}</span>
      </a>
    ),
  )

  return (
    <>
      <div className={styles.panel}>
        <div className={styles.services_group}>
          <a href="/service" target="_blank" rel="noopener">
            <span className={styles.category}>Services</span>
          </a>
          <div className={styles.detail_group}>{serviceList}</div>
        </div>
        <div className={styles.pageList}>{categoryList}</div>
      </div>
    </>
  )
}

export default LPFooterNav
